import { ForwardedRef, forwardRef } from 'react';
import { TextInput, TextStyle } from 'react-native';
import { SearchInputProps } from './SearchInput.types';
import useStyle from '../../hooks/useStyle';
import Input from '../Input/Input';

function SearchInput(props: SearchInputProps, ref: ForwardedRef<TextInput>) {
  const { color } = useStyle<TextStyle>({ color: 'darkSurfaceSecondary' });

  return (
    <Input
      {...props}
      ref={ref}
      icon="search"
      placeholderTextColor={color}
      borderRadius="radius-full"
    />
  );
}

export default forwardRef<TextInput, SearchInputProps>(SearchInput);
